import * as React from 'preact/compat'
import Api from '../../api'
import { SGPlugin } from '../../common/SGPlugins'
import { showToast } from '../../components/toast'
import { insertPJAXHead, log } from "../../common/helpers";
import Loading from "../../components/Loading";

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLButtonElement>) => {
  elements.forEach(element => {
    const selector = element.getAttribute('data-load-more')
    const options = SGPlugin.getElementOptions<{
      url: string
      pageSize?: number,
      offset?: number,
      onScroll?: boolean
    }>(element, 'load-more', true, {
      'page-size': 'pageSize',
      'on-scroll': 'onScroll'
    })
    let offset = options.offset || options.pageSize || 0
    const limit = options.pageSize || 10
    const innerHTML = element.innerHTML
    let loading = false
    const container = document.querySelector(selector)
    let observer: IntersectionObserver
    const load = () => {
      if (loading) {
        return
      }
      loading = true
      observer?.disconnect()
      if (options.onScroll) {
        React.render(<Loading/>, element)
      } else {
        element.innerHTML = 'Загружаем...'
      }
      const url = new URL(window.location.protocol + '//' + window.location.host + '/ajax/' + options.url)
      const searchParams = url.searchParams
      searchParams.set('offset', offset.toString())
      searchParams.set('limit', limit.toString())
      const pathname = url.pathname.replace('/ajax/', '')
      Api.get({ url: pathname + '?' + searchParams.toString() })
        .then(response => {
          if (response.head) {
            insertPJAXHead(response.head)
          }
          if (response.content) {
            const content = document.createElement('div')
            content.innerHTML = response.content
            Array.from(content.children).forEach(node => {
              if (node.getAttribute('data-key')) {
                const existingNode = document.querySelector(`[data-key="${node.getAttribute('data-key')}"]`)
                if (existingNode) {
                  log('Load More', 'Existing node', node.getAttribute('data-key'))
                  return
                }
              }
              container.append(node)
            })
          }
          if (response.svg) {
            const svgContainer = document.querySelector('#svg-sprite');
            const content = document.createElement('div')
            content.innerHTML = response.svg
            Array.from(content.querySelector('#svg-sprite').children).forEach(symbol => {
              const symbolId = symbol.getAttribute('id')
              const existingSymbol = document.querySelector(`[id="${symbolId}"]`)
              if (!existingSymbol) {
                svgContainer.append(symbol)
              }
            })
          }
          if (response.offset) {
            offset = response.offset
          }
          if (!response.hasMore) {
            element.parentElement.replaceChild(document.createElement('div'), element)
          } else {
            loading = false
            if (options.onScroll) {
              React.unmountComponentAtNode(element)
            }
            element.innerHTML = innerHTML
          }
          window.dispatchEvent(new CustomEvent('load-more', {
            detail: {
              url: options.url
            }
          }))
        })
        .catch((err) => {
          console.error(err)
          showToast({
            type: 'error',
            text: 'Не удалось загрузить данные',
          })
          loading = false
          if (options.onScroll) {
            React.unmountComponentAtNode(element)
          }
          element.innerHTML = innerHTML
        })
        .finally(() => {
          if (options.onScroll) {
            observer.observe(element)
          }
        })
    }
    if (options.onScroll) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            load()
          }
        })
      }, {
        root: null,
        rootMargin: '500px 0px 0px 0px',
        threshold: 0.1
      })
      observer.observe(element)
    } else {
      element.addEventListener('click', load)
    }
  })
}
